(() => {
  'use strict';

  const roots = document.querySelectorAll('[data-oeo-custom-studio]');
  roots.forEach(init);

  function init(root) {
    const form = root.querySelector('[data-studio-form], #OeoCustomWallpaperForm');
    if (!form || form.dataset.ready === 'true') return;
    form.dataset.ready = 'true';
    form.dataset.studioForm = '';
    form.noValidate=true;
    form.classList.add('is-enhanced');
    const fallback=form.querySelector('[data-form-fallback]');if(fallback) fallback.hidden=true;

    let step = 1;
    const stepEls = [...form.querySelectorAll('[data-studio-step]')];
    const progressEls = [...form.querySelectorAll('[data-progress]')];
    const progress = form.querySelector('.oeo-cw__progress');
    const panels = [...form.querySelectorAll('[data-panel]')];
    const submitButton = form.querySelector('[data-submit-brief]');
    const success = form.querySelector('[data-brief-success]');
    const notMeasured = form.querySelector('#oeoNotMeasured');
    const widthInput = form.querySelector('#oeoWallWidth');
    const heightInput = form.querySelector('#oeoWallHeight');
    const wallShape = form.querySelector('[data-wall-shape]');
    const wallSize = form.querySelector('[data-wall-size]');
    const firstNext = form.querySelector('[data-next="2"]');
    const mobileSticky = root.querySelector('.oeo-cw__mobile-sticky');
    let inFlight=false, confirmed=false, pending=null;
    // Clear data left by the retired form; never write customer data to browser storage.
    try { sessionStorage.removeItem('oeoCustomWallpaperPendingBrief'); } catch (_) {}
    panels.forEach(panel=>{panel.hidden=true;panel.querySelectorAll('input,textarea,select').forEach(el=>{el.disabled=true;});});

    if (firstNext) firstNext.disabled = !selectedPath();
    if (mobileSticky && 'IntersectionObserver' in window) {
      const observer = new IntersectionObserver(entries => {
        mobileSticky.classList.toggle('is-hidden', entries.some(entry => entry.isIntersecting));
      }, { rootMargin: '-10% 0px -10% 0px', threshold: 0 });
      observer.observe(root.querySelector('#oeoCustomStudio'));
      observer.observe(root.querySelector('.oeo-cw__final'));
    }

    root.querySelectorAll('[data-start-studio]').forEach(button => {
      button.addEventListener('click', () => {
        const target = root.querySelector('#oeoCustomStudio');
        target.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        setTimeout(() => {
          const first = form.querySelector('[data-design-path]');
          if (first) first.focus({ preventScroll: true });
        }, reducedMotion() ? 0 : 450);
        publish('custom_wallpaper_studio_started', {});
      });
    });

    form.querySelectorAll('[data-design-path]').forEach(input => {
      input.addEventListener('change', () => {
        form.querySelectorAll('.oeo-cw__path').forEach(card => card.classList.toggle('is-selected', card.contains(input)));
        panels.forEach(panel => { panel.hidden = panel.dataset.panel !== input.dataset.designPath;panel.querySelectorAll('input,textarea,select').forEach(el=>{el.disabled=panel.hidden;}); });
        if (firstNext) firstNext.disabled = false;
        clearError(1);
        updateBrief();
        publish('custom_wallpaper_path_selected', { path: input.dataset.designPath });
      });
    });

    form.querySelectorAll('[data-next]').forEach(button => {
      button.addEventListener('click', () => {
        const next = Number(button.dataset.next);
        if (!validateStep(step)) return;
        showStep(next);
        if (next === 4) publish('custom_wallpaper_brief_built', { path: selectedPath() });
      });
    });

    form.querySelectorAll('[data-back]').forEach(button => {
      button.addEventListener('click', () => showStep(Number(button.dataset.back)));
    });

    form.addEventListener('submit', submitBrief);
    form.addEventListener('input', () => {
      updateWall();
      updateBrief();
    });
    form.addEventListener('change', () => {
      updateWall();
      updateBrief();
    });

    if (notMeasured) {
      notMeasured.addEventListener('change', () => {
        [widthInput, heightInput].forEach(input => {
          input.disabled = notMeasured.checked;
          if (notMeasured.checked) input.value = '';
        });
        updateWall();
        updateBrief();
      });
    }

    showStep(1, false);
    updateWall();updateBrief();

    function showStep(next, scroll = true) {
      step = Math.max(1, Math.min(4, next));
      stepEls.forEach(el => {
        const active = Number(el.dataset.studioStep) === step;
        el.hidden = !active;
        el.classList.toggle('is-active', active);
      });
      progressEls.forEach(el => {
        const n = Number(el.dataset.progress);
        el.classList.toggle('is-active', n === step);
        el.classList.toggle('is-complete', n < step);
        if (n === step) el.setAttribute('aria-current', 'step'); else el.removeAttribute('aria-current');
      });
      clearError(step);
      if (step === 4) updateBrief();
      if (scroll) {
        form.scrollIntoView({ behavior: reducedMotion() ? 'auto' : 'smooth', block: 'start' });
        setTimeout(() => {
          const focusTarget = stepEls.find(el => Number(el.dataset.studioStep) === step)?.querySelector('legend, input:not([type="hidden"]), textarea, select');
          if (focusTarget) {
            if (!focusTarget.hasAttribute('tabindex') && focusTarget.tagName === 'LEGEND') focusTarget.setAttribute('tabindex', '-1');
            focusTarget.focus({ preventScroll: true });
          }
        }, reducedMotion() ? 0 : 350);
      }
    }

    function validateStep(current) {
      for(const input of form.querySelectorAll(`[data-studio-step="${current}"] [data-max-length]`)){
        if(!input.disabled&&input.value.length>Number(input.dataset.maxLength))return error(current,'Please shorten this field to '+input.dataset.maxLength+' characters. Your text has not been shortened.',input);
      }
      if (current === 1 && !selectedPath()) return error(1, 'Choose how you would like to begin.');
      if (current === 2 && !notMeasured.checked) {
        const w = Number(widthInput.value), h = Number(heightInput.value);
        if ((widthInput.value && (!Number.isFinite(w) || w <= 0 || w>1440)) || (heightInput.value && (!Number.isFinite(h) || h <= 0 || h>370))) return error(2, 'Enter valid wall measurements, or select “I have not measured yet”.');
        if ((widthInput.value && !heightInput.value) || (!widthInput.value && heightInput.value)) return error(2, 'Add both wall width and height, or leave both blank.');
      }
      if (current === 4) {
        const name = form.querySelector('#oeoName');
        const email = form.querySelector('#oeoEmail');
        const consent = form.querySelector('#oeoConsent');
        if (!name.value.trim()) return error(4, 'Add your name so our design team knows who the brief is from.', name);
        if (!email.validity.valid || !email.value.trim()) return error(4, 'Add a valid email address.', email);
        if (!consent.checked) return error(4, 'Confirm the artwork permission and custom wallpaper terms.', consent);
      }
      clearError(current);
      return true;
    }

    function error(which, message, target) {
      const el = form.querySelector(`[data-error="${which}"]`);
      if (el) {el.id='oeo-error-'+which;el.textContent = message;}
      if (target) {target.setAttribute('aria-invalid','true');const ids=new Set((target.getAttribute('aria-describedby')||'').split(' ').filter(Boolean));ids.add('oeo-error-'+which);target.setAttribute('aria-describedby',[...ids].join(' '));target.focus();}
      return false;
    }

    function clearError(which) {
      const el = form.querySelector(`[data-error="${which}"]`);
      if (el) el.textContent = '';
      form.querySelector(`[data-studio-step="${which}"]`)?.querySelectorAll('[aria-invalid]').forEach(input=>input.removeAttribute('aria-invalid'));
    }

    function selectedPath() {
      return form.querySelector('[data-design-path]:checked')?.dataset.designPath || '';
    }

    function updateWall() {
      if (!wallShape || !wallSize) return;
      const w = Number(widthInput.value), h = Number(heightInput.value);
      if (!notMeasured.checked && w > 0 && h > 0) {
        const ratio = Math.max(.65, Math.min(2.6, w / h));
        wallShape.style.aspectRatio = String(ratio);
        wallShape.style.width = `${Math.max(54, Math.min(96, 54 + (ratio - .65) * 22))}%`;
        wallSize.textContent = `${cleanNumber(w)} cm wide × ${cleanNumber(h)} cm high`;
      } else {
        wallShape.style.aspectRatio = '1.5';
        wallShape.style.width = '86%';
        wallSize.textContent = notMeasured.checked ? 'We will help you measure' : 'Width × height';
      }
    }

    function collectBrief() {
      const path = selectedPath();
      const pathNames = { oeo: 'Customise an Olive et Oriel design', own: 'Use my own artwork', new: 'Create something new' };
      const changes = [...form.querySelectorAll('[data-change-option]:checked')].map(x => x.dataset.changeOption);
      const w = widthInput.value.trim(), h = heightInput.value.trim();
      const dimensions = notMeasured.checked ? 'Not measured yet' : (w && h ? `${cleanNumber(w)} cm wide × ${cleanNumber(h)} cm high` : 'To be confirmed');
      const brief = {
        starting_point: pathNames[path] || 'Not selected',
        oeo_design: value('#oeoProduct') || 'Not supplied',
        artwork_description: value('#oeoArtworkDescription') || 'Not supplied',
        initial_idea: value('#oeoIdea') || 'Not supplied',
        wall_dimensions: dimensions,
        room: value('#oeoRoom') || 'Not supplied',
        project_type: value('#oeoProject') || 'Residential',
        requested_changes: changes.length ? changes.join(', ') : 'Please guide me',
        colours: value('#oeoColours') || 'Not supplied',
        needed_by: value('#oeoDeadline') || 'No date supplied',
        notes: value('#oeoNotes') || 'None'
      };
      for(const [field,active] of [['oeo_design','oeo'],['artwork_description','own'],['initial_idea','new']])if(path!==active)delete brief[field];
      return brief;
    }

    function updateBrief() {
      const brief = collectBrief();
      const labels = {
        starting_point: 'Starting point', oeo_design: 'Olive et Oriel design', artwork_description: 'Artwork or image', initial_idea: 'Initial idea',
        wall_dimensions: 'Wall', room: 'Room', project_type: 'Project', requested_changes: 'Changes', colours: 'Colours', needed_by: 'Needed by', notes: 'Notes'
      };
      const path = selectedPath();
      const summary = form.querySelector('[data-brief-summary]');
      if (summary) {
        summary.innerHTML = '<dl>' + Object.entries(brief).filter(([key]) => !((key === 'oeo_design' && path !== 'oeo') || (key === 'artwork_description' && path !== 'own') || (key === 'initial_idea' && path !== 'new'))).map(([key, val]) => `<dt>${escapeHtml(labels[key])}</dt><dd>${escapeHtml(val)}</dd>`).join('') + '</dl>';
      }
      return brief;
    }

    async function submitBrief(event) {
      event.preventDefault();
      if(inFlight||confirmed)return;
      for(const n of [1,2,3,4]) if(!validateStep(n)){showStep(n,false);validateStep(n);return;}
      if(value('#oeoWebsite'))return error(4,'Unable to send this request.');
      const captcha=form.querySelector('[name="cf-turnstile-response"]')?.value||'';
      if(!captcha)return error(4,'Complete the verification above, then send your request.');
      const params=new URLSearchParams(location.search),brief=updateBrief();
      const data={...brief,customer_name:value('#oeoName'),customer_email:value('#oeoEmail'),terms:form.querySelector('#oeoConsent').checked,source_url:'https://oliveetoriel.com/pages/custom-wallpaper-made-just-for-you',utm_source:params.get('utm_source')||'',utm_medium:params.get('utm_medium')||'',utm_campaign:params.get('utm_campaign')||''};
      const fingerprint=JSON.stringify(data);
      if(!pending||pending.fingerprint!==fingerprint)pending={fingerprint,id:crypto.randomUUID()};
      const payload={...data,unique_id:pending.id,captcha_token:captcha};
      if(new TextEncoder().encode(JSON.stringify(payload)).length>65536)return error(4,'Your brief exceeds the 64 KB total limit. Please shorten it or email the complete version to custom@oliveetoriel.com. Nothing has been sent.');
      inFlight=true;submitButton.disabled=true;submitButton.setAttribute('aria-busy','true');submitButton.textContent='Saving your brief…';clearError(4);
      const controls=[...form.querySelectorAll('input,select,textarea,button')].filter(el=>!el.disabled&&el!==submitButton);controls.forEach(el=>{el.disabled=true;});
      try {
        const response=await fetch('https://oeo-custom-wallpaper-briefs.pages.dev/api/brief',{method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify(payload),signal:AbortSignal.timeout(25000)});
        const receipt=await response.json();
        if(!response.ok||receipt.ok!==true||receipt.status!=='stored'||receipt.receipt_id!==pending.id||receipt.recipient!=='custom@oliveetoriel.com'){
          if(response.status===403&&window.turnstile)window.turnstile.reset('#oeoBriefCaptcha');
          if(response.status===422)throw new Error('Please check '+(receipt.field||'the highlighted fields')+'. The permitted length is '+(receipt.max||'shown by the field')+' characters. Nothing has been shortened.');
          if(response.status===429)throw new Error('Too many attempts. Please wait before trying again, or contact custom@oliveetoriel.com.');
          if(response.status===403)throw new Error('Verification was not accepted. Complete it again, then resend.');
          throw new Error('We could not confirm your brief was saved. Your details remain here. Please retry; the same request will not be saved twice.');
        }
        confirmed=true;
        if(progress)progress.hidden=true;
        stepEls.forEach(el=>{el.hidden=el.dataset.studioStep!=='4';});
        stepEls.find(el=>el.dataset.studioStep==='4').querySelectorAll('fieldset,[data-error],.oeo-cw__step-actions,.oeo-cw__privacy,[data-captcha-wrap]').forEach(el=>{el.hidden=true;});
        success.querySelector('[data-receipt-id]').textContent='Reference: '+receipt.receipt_id;
        success.hidden=false;success.focus();
        publish('custom_wallpaper_brief_submitted',{receipt_id:receipt.receipt_id});
      } catch(e) {
        error(4,e.name==='TimeoutError'||e.name==='TypeError'?'We could not confirm your brief was saved. Your details remain here. Retry to check the same request without creating a duplicate.':e.message);
      } finally {
        inFlight=false;
        if(!confirmed){controls.forEach(el=>{el.disabled=false;});submitButton.disabled=false;submitButton.removeAttribute('aria-busy');submitButton.textContent='Send my request';}
      }
    }

    function value(selector) {
      return form.querySelector(selector)?.value?.trim() || '';
    }

    function cleanNumber(value) {
      const n = Number(value);
      return Number.isFinite(n) ? String(Math.round(n * 10) / 10) : String(value);
    }
  }

  function escapeHtml(value) {
    return String(value).replace(/[&<>'"]/g, char => ({'&':'&amp;','<':'&lt;','>':'&gt;',"'":'&#39;','"':'&quot;'}[char]));
  }

  function reducedMotion() {
    return window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function publish(name, data) {
    try {
      if (window.Shopify?.analytics?.publish) window.Shopify.analytics.publish(name, data);
    } catch (_) {}
  }
})();
